
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { VMenu } from 'vuetify/lib';
import { ContextMenuItem } from '@/../types/interfaces';
import { VueConstructor } from 'vue';
import { VuetifyMixin } from '@/mixins';

@Component
export default class ContextMenu extends Mixins(VuetifyMixin){
	@Prop({ required: true, default: [{icon: 'mdi-plus', text: 'Add'}] }) items: ContextMenuItem[];
	@Prop({ default: "baColorDeepBlue" }) color: string;
	@Prop({ default: "grey lighten-3" }) menuIconColor: string;
	@Prop({ default: true, type: Boolean }) dark: boolean;
	@Prop({ default: false, type: Boolean }) darkIcon: boolean;
	@Prop({ default: 'mdi-dots-horizontal' }) icon: string;
	@Prop({ default: 'grey' }) iconColor: string;
	@Prop({ default: false, type: Boolean }) inline: boolean;

	get Color(): string{
		return this.getColor(this.color);
	}
	get MenuIconColor(): string{
		return this.getColor(this.menuIconColor);
	}

	get TextClass():Record<string, boolean>{
		return {
			[`${this.menuIconColor}--text`]: this.inline,
		};
	}

	get RootComponent(): string | VueConstructor{
		if(this.inline === true){
			return 'div';
		}
		return VMenu;
	}

	clickItem(item: ContextMenuItem): void{
		this.$emit('click:item', { item });
		if(item.click) item.click();
	}
}
